import getWindow from './getWindow';

const getWindowLocation = () => getWindow()?.location;

export default getWindowLocation;
